import { Component } from '@angular/core';
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { RouteComment } from '../../models/route-comment.model';
import { Data } from '@angular/router';
@Component({
  selector: 'app-route-comment-admin-page',
  templateUrl: 'route-comment-admin.page.html',
  styleUrls: [
    './route-comment-admin.page.scss',
  ]
})
export class RouteCommentAdminPage {
  settingsFields:any[];
  routeComments:RouteComment[];
  loading:boolean=true ;
  Add_Display_Order2:number;
  Add_Display_Order1:number;
  Add_Text1="";
  Add_Text2="";
    constructor(
        private systemSettingService: SystemSettingService,
        private toasterService: ToasterService,
      ) { 
  
    }
 ngOnInit() {
  this.loadData();
   
  }
  async loadData() {
    this.loading=false;
    await this.systemSettingService.getRouteComment().then((response) => {
      
        this.routeComments = response;
      });
        this.loading=true;

    }
  toggleSelection(setting: any, event: any) {
    setting.data = event.detail.checked;
  }

  async submitForm() {
    this.loading=false;
    
  if (this.Add_Text1  != null) {
    if(this.Add_Display_Order1==null){
      this.Add_Display_Order1=10;
    }
    const newComment = new RouteComment();
    newComment.comment = this.Add_Text1;
    newComment.displayOrder = this.Add_Display_Order1;
    this.routeComments.push(newComment);
    this.Add_Text1="";
    this.Add_Display_Order1=null;
  }
    if (this.Add_Text2 != null) {
      if(this.Add_Display_Order2==null){
        this.Add_Display_Order2=10;
       }
    const newComment = new RouteComment();
    newComment.comment = this.Add_Text2;
    newComment.displayOrder = this.Add_Display_Order2;
    this.routeComments.push(newComment);
    this.Add_Text2="";
    this.Add_Display_Order2=null;
  }
    
     await  this.systemSettingService.updateRouteComment(this.routeComments).then((response) => {
      if (response =='success') {
        this.toasterService.presentToast(
          "primary",
          "The route comment were updated.",
          "Success"
        );
        this.loadData();
      } else {
        this.toasterService.presentToast(
          "danger",
          `Error adding route Comment. ${response}`,
          "Error"
        );
      }
    });
this.loading=true;

  }

}